import { HeadingOne } from './HeadingOne'

type Props = {
  children?: React.ReactNode
  className?: string
}
function PageTitle({ children, className }: Props) {
  return (
    <div className="px-5 md:px-10 pt-15 md:pt-30 pb-5 md:pb-10">
      <HeadingOne className={className}>{children}</HeadingOne>
    </div>
  )
}

export { PageTitle }
